import React from 'react';

import { SERIES_PATHNAME } from '~/src/common/routes';
import { navigate } from '~/src/common/utilities';
import { WithPlaceholder } from '~/src/components/carousels';
import type { BaseCarouselComposerProps } from '~/src/components/carousels/BaseCarousel';

import type { CarouselItem } from './types';

import { useSeriesAlgoliaSearch } from './useSeriesAlgoliaSearch';
import { SeriesCarousel } from '../SeriesCarousel';

type Props = Omit<BaseCarouselComposerProps<CarouselItem>, 'items'>;

export const AllSeriesCarousel: React.FC<Props> &
  WithPlaceholder<React.ComponentProps<typeof SeriesCarousel.Placeholder>> = props => {
  const { loading, hits } = useSeriesAlgoliaSearch();
  if (loading) {
    return <SeriesCarousel.Placeholder />;
  }

  const carouselItems = hits?.[0] ? hits[0].items : [];
  return (
    <SeriesCarousel
      {...props}
      items={carouselItems}
      onHeaderClick={() => navigate(SERIES_PATHNAME)}
    />
  );
};

AllSeriesCarousel.Placeholder = SeriesCarousel.Placeholder;
